// extracted by mini-css-extract-plugin
export default {"search__container":"SearchContainer_search__container__tDiqE"};